import type {ImageField, KeyTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import {PrismicNextImage} from '@prismicio/next/pages'
import cn from 'classnames'
import {TAG_COLORS} from 'src/common/constants'

type TagProps = {
  icon?: ImageField
  label: KeyTextField
  color?: keyof typeof TAG_COLORS
  variant?: 'default' | 'small' | 'xsmall'
  enableReskin?: boolean
}

export const Tag = ({label, color, variant = 'default', icon, enableReskin = false}: TagProps) => (
  <p
    className={cn('flex size-fit items-center bg-[#222B271A]/10 font-medium uppercase text-grey-450', {
      'text-body-xs px-2 py-1': variant === 'default',
      'text-body-xxs px-1.5 py-0.5': variant === 'small',
      'text-body-xs-caps-500 px-1.5 py-0.5': variant === 'xsmall',
      'flex gap-2 py-2 px-5 text-body': isFilled.image(icon),
      'rounded-full': !enableReskin,
      'text-[10px] leading-[14px] tracking-[0.2px] uppercase rounded-[2px]': enableReskin,
    })}
    {...(color && {style: TAG_COLORS[enableReskin ? 'green-reskin' : color]})}
  >
    {isFilled.image(icon) && <PrismicNextImage field={icon} className="size-5" />}
    {label}
  </p>
)
